import { kitText } from './messages.ts';
import { Callout, Panel } from './ui.tsx';

/**
 * The build has no API address.
 *
 * There is deliberately no default for `VITE_API_BASE`: one silently pointing
 * at localhost is one somebody deploys and then debugs as an outage.
 *
 * But all three portals used to `throw` at module scope, which renders a white
 * page and puts the reason in a console nobody has open. Whoever hits it — the
 * person who built without the variable, or a customer following a link to a
 * misconfigured deployment — sees nothing at all and reports "the site is
 * down". Refusing loudly and refusing invisibly are not the same thing, and
 * only the second one wastes an afternoon.
 *
 * Shared because it was fixed in the AffDice Admin first and left broken in
 * the other two, which is how the timestamp bug came back after being fixed at
 * one end of it.
 */
export function NotConfigured({ portal }: { portal: string }) {
  return (
    <div className="main signin">
      <div className="page-head"><h1>{kitText('notConfigured.title')}</h1></div>
      <Panel title={kitText('notConfigured.panel')}>
        <Callout tone="error">
          {/* The variable name stays a code span and an identifier (§2.8b);
              the sentence around it moves, because the three languages do not
              put it in the same place. */}
          {kitText('notConfigured.unset', { variable: 'VITE_API_BASE', portal })}{' '}
          {kitText('notConfigured.rebuild')}{' '}
          <code>VITE_API_BASE=https://api.example pnpm build</code>.{' '}
          {kitText('notConfigured.noDefault')}
        </Callout>
      </Panel>
    </div>
  );
}
